import "./index.css";
import { useState, useEffect } from "react";

const Nav = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const isActive = (linkName) => activeSection === linkName;

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      // Update state based on scroll position
      setIsScrolled(scrollY > 50);
    };

    const requestTick = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', requestTick, { passive: true });
    // Initial call to set correct state on mount
    handleScroll();
    
    return () => window.removeEventListener('scroll', requestTick);
  }, []);

  return (
    <nav className={`nav-styles ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner-styles">
        <div className="title-left-styles">
          <h1 className="title-left-styles-heading">Laura Terruso</h1>
        </div>
        <ul className="ul-list-right-styles">
          {['about', 'trailers', 'press', 'contact'].map((section) => (
            <li className="ul-list-right-item-styles" key={section}>
              <a href={`#${section}`} className={isActive(section) ? 'active' : ''}>
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
